import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ArrivalService } from '../../../admin/_services/arrival/arrival.service';
import { GetWorkStationDisplayResponse } from '../../../typescript/getWorkStationDisplayResponse';
import { WorkStationDisplayModel } from '../../../typescript/workStationDisplayModel';
import { WorkReservationDisplayModel } from '../../../typescript/workReservationDisplayModel';
import { WorkQueueDisplayModel } from '../../../typescript/workQueueDisplayModel';
import { ReservationState } from '../../../typescript/reservationState';
import { WorkState } from '../../../typescript/workState';
import { VehicleType } from '../../../typescript/vehicleType';
import { VehicleService } from '../../../shared/services/vehicle.service';
import { SyncVehicleTypeData } from '../../../typescript/syncVehicleTypeData';
import { SyncedVehicleTypes } from '../../../typescript/syncedVehicleTypes';
import { VehicleTypeDefinitionPublicModel } from '../../../typescript/vehicleTypeDefinitionPublicModel';
import { ServiceType } from 'src/app/typescript/serviceType';
import { PlateNumberDirective } from '../../_directives/plate-number.directive';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../admin/globals.service';

@Component({
  standalone: true,
  selector: 'app-display',
  templateUrl: './display.component.html',
  styleUrls: ['./display.component.scss'],
  imports: [PlateNumberDirective, TranslateModule],
})
export class DisplayComponent {
  arrivalService = inject(ArrivalService);
  route = inject(ActivatedRoute);
  vehicleService = inject(VehicleService);
  private translate = inject(TranslateService);
  private globals = inject(Globals);

  public serviceTypes = ServiceType;
  public displayCode: string;
  public display: DisplayColumns[] = new Array<DisplayColumns>();
  public workQueues = new Array<WorkQueueDisplayModel>();
  mVehicleType = VehicleType;
  unloggedUserVehicles = new Array<VehicleTypeDefinitionPublicModel>();

  constructor() {
    this.translate.setDefaultLang(this.globals.getLang().split('-')[0]);
    this.route.params.subscribe((next) => {
      this.vehicleService
        .syncVehicles({ referenceDate: new Date(1991, 1, 1) } as SyncVehicleTypeData)
        .subscribe((ok: SyncedVehicleTypes) => {
          const obj = ok.createdOrModifiedVehicleTypes;
          if (obj !== null) {
            const sortedVehicleTypes = obj.sort(function (a, b) {
              return a.make.localeCompare(b.make);
            });
            for (const make in sortedVehicleTypes) {
              this.unloggedUserVehicles[obj[make].id] = obj[make];
            }
          }
        });

      this.displayCode = next.id;

      this.arrivalService.getDisplaydata(next.id).subscribe((ok: GetWorkStationDisplayResponse) => {
        this.display = new Array<DisplayColumns>();
        this.workQueues = ok.workQueues.filter((x) => {
          return x.workState !== WorkState.IN_PROGRESS;
        });
        for (const ws of ok.workStations) {
          const column = new DisplayColumns();
          column.station = ws;
          column.reservations = ok.workReservations.filter((x) => {
            return x.workStationId === ws.id && x.reservationState !== ReservationState.IN_PROGRESS;
          });
          column.currentlySelectedReservation = ok.workReservations.find((x) => {
            return x.workStationId === ws.id && x.reservationState === ReservationState.IN_PROGRESS;
          });
          column.currentlySelectedQueue = ok.workQueues.find((x) => {
            return x.workStationId === ws.id && x.workState === WorkState.IN_PROGRESS;
          });
          this.display.push(column);
        }

        const t = window.setInterval(() => {
          this.arrivalService.getDisplaydata(next.id).subscribe((ok: GetWorkStationDisplayResponse) => {
            this.display = new Array<DisplayColumns>();
            this.workQueues = ok.workQueues.filter((x) => {
              return x.workState !== WorkState.IN_PROGRESS;
            });
            for (const ws of ok.workStations) {
              const column = new DisplayColumns();
              column.station = ws;
              column.reservations = ok.workReservations.filter((x) => {
                return x.workStationId === ws.id && x.reservationState !== ReservationState.IN_PROGRESS;
              });

              column.currentlySelectedReservation = ok.workReservations.find((x) => {
                return x.workStationId === ws.id && x.reservationState === ReservationState.IN_PROGRESS;
              });
              column.currentlySelectedQueue = ok.workQueues.find((x) => {
                return x.workStationId === ws.id && x.workState === WorkState.IN_PROGRESS;
              });
              this.display.push(column);
            }
          });
        }, 30000);
      });
    });
  }

  getVehicleName(num) {
    return this.mVehicleType[num];
  }

  getBoxes(i) {
    if (this.display1()[i].reservations.slice(0, 5).length < 5) {
      const x = this.display1()[i].reservations.slice(0, 5);
      for (let j = this.display1()[i].reservations.slice(0, 5).length; j < 5; j++) {
        const a = new WorkReservationDisplayModel();
        a.workStationId = -1;
        x.push(a);
      }
      return x;
    } else {
      return this.display1()[i].reservations.slice(0, 5);
    }
  }

  getQBoxes() {
    if (this.workQueues.length < 5) {
      const x = this.workQueues.slice(0, 5);
      for (let j = this.workQueues.slice(0, 5).length; j < 5; j++) {
        const b = new WorkQueueDisplayModel();
        b.workStationId = -1;
        x.push(b);
      }
      return x;
    } else {
      return this.workQueues.slice(0, 5);
    }
  }
  display1() {
    return this.display.filter((x) => {
      return x.station.stationState === 1;
    });
  }
  display2() {
    return this.display.filter((x) => {
      return x.station.stationState === 0;
    });
  }

  getBoxService(box: WorkReservationDisplayModel) {
    if (box.serviceType !== ServiceType.EXTRA_SERVICE) {
      return this.serviceTypes[box.serviceType];
    }
    return box.extraServiceName;
  }

  getCurrentlySelectedReservationService(box: WorkReservationDisplayModel) {
    if (box.serviceType !== ServiceType.EXTRA_SERVICE) {
      return this.serviceTypes[box.serviceType];
    }
    return box.extraServiceName;
  }
}

export class DisplayColumns {
  station: WorkStationDisplayModel;
  reservations: WorkReservationDisplayModel[];
  queues: WorkQueueDisplayModel[];
  currentlySelectedReservation: WorkReservationDisplayModel;
  currentlySelectedQueue: WorkQueueDisplayModel;
}
